import * as React from 'react';
import { Link as LinkComponent } from 'react-router-dom';
import { FooterLinkModel } from '../';
import { SocialLink } from '../../../../Common/SocialLink';
import './style.css';

export interface FooterLinkListItemProps {
  link: FooterLinkModel;
}

export interface FooterLinkListItemState {
  /* empty */
}

export interface Link {
  icon?: string;
  text: string;
  url: string;
}

export class FooterLinkListItem extends React.Component<
  FooterLinkListItemProps,
  FooterLinkListItemState
> {
  render() {
    const { link } = this.props;

    return <li className="footer-links-item">{this.getLink(link)}</li>;
  }

  private getLink = (link: FooterLinkModel) => {
    if (link.icon) {
      return this.getSocialLink(link);
    }

    return this.getBasicLink(link);
  };

  private getSocialLink = (link: FooterLinkModel) => {
    const socialLinkClasses = 'footer-links-item-link footer-links-social-link';

    const classNames = link.className
      ? `${socialLinkClasses} ${link.className}`
      : socialLinkClasses;

    return (
      <SocialLink
        className={classNames}
        icon={(link as { icon: string }).icon}
        text={link.title}
        url={link.url}
      />
    );
  };

  private getBasicLink = (link: FooterLinkModel) => {
    const linkClasses = 'edge-of-play-link footer-links-item-link';

    const classNames = link.className
      ? `${linkClasses} ${link.className}`
      : linkClasses;

    return (
      <LinkComponent className={classNames} to={link.url}>
        {link.title}
      </LinkComponent>
    );
  };
}

export default FooterLinkListItem;



// WEBPACK FOOTER //
// ./src/app/components/App/Footer/FooterLinks/FooterLinkListItem/index.tsx